module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_cistuskapseln.e70f0800.png";